import React from "react";

import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import fulfillment from "./AccountSelection.fulfillment";
import OptionsList from "../../../components/OptionsList/OptionsList";
import TextView from "../../../../../components/TextView/TextView";

export default class AccountSelection extends React.PureComponent
{
	state = _getInitialState.call(this);
	fields = AccountSelection.getFields();

	isFulfilled(state)
	{
		return fulfillment(state, this.state);
	}

	componentDidMount()
	{
		// Signal to parent whether this component has been fulfilled or not
		const accountAf = this.state.customerState.chk_accounttype_naked === "yes";
		const accountIsk = this.state.customerState.chk_accounttype_isk === "yes";
		const accountTp = this.state.customerState.chk_accounttype_tp === "yes";
		const accountKf = this.state.customerState.chk_accounttype_kf === "yes";
		this.props.onUpdated(this.state.isFulfilled, accountAf, accountIsk, accountKf, accountTp);
	}

	setCustomerState(customerState)
	{
		customerState = {...this.state.customerState, ...customerState};
		this.setState({
			customerState,
			isFulfilled: this.isFulfilled({customerState})
		}, () =>
		{
			const accountAf = this.state.customerState.chk_accounttype_naked === "yes";
			const accountIsk = this.state.customerState.chk_accounttype_isk === "yes";
			const accountKf = this.state.customerState.chk_accounttype_kf === "yes";
			const accountTp = this.state.customerState.chk_accounttype_tp === "yes";
			this.props.onUpdated(this.state.isFulfilled, accountAf, accountIsk, accountKf, accountTp);
		});
	}

	render()
	{
		const {props, state} = this;
		const {customer, onboardingInfo, highlightErrors, readOnly} = props;
		const {customerState} = state;

		let accountTypeOptions;
		if (state.workflow === "futur")
		{
			accountTypeOptions = [
				{
					name: "chk_accounttype_kf",
					label: "Depå kapitalförsäkring",
					value: "yes",
					checked: customerState.chk_accounttype_kf === "yes",
					onChange: checked => this.setCustomerState({chk_accounttype_kf: checked ? "yes" : "no"})
				},
				{
					name: "chk_accounttype_tp",
					label: "Depå tjänstepensionsförsäkring",
					value: "yes",
					checked: customerState.chk_accounttype_tp === "yes",
					onChange: checked => this.setCustomerState({chk_accounttype_tp: checked ? "yes" : "no"})
				}
			];
		}
		else if (customer.isCompany)
		{
			accountTypeOptions = [
				{
					name: "chk_accounttype_naked",
					label: "Aktie- & fondkonto",
					value: "yes",
					checked: !onboardingInfo.has_naked_account || customerState.chk_accounttype_naked === "yes",
					onChange: checked => this.setCustomerState({chk_accounttype_naked: !onboardingInfo.has_naked_account || checked ? "yes" : "no"})
				},
				{
					name: "chk_accounttype_kf",
					label: "Depå kapitalförsäkring",
					value: "yes",
					checked: customerState.chk_accounttype_kf === "yes",
					onChange: checked => this.setCustomerState({chk_accounttype_kf: checked ? "yes" : "no"})
				},
				{
					name: "chk_accounttype_tp",
					label: "Depå tjänstepensionsförsäkring",
					value: "yes",
					checked: customerState.chk_accounttype_tp === "yes",
					onChange: checked => this.setCustomerState({chk_accounttype_tp: checked ? "yes" : "no"})
				}
			];
		}
		else
		{
			accountTypeOptions = [
				{
					name: "chk_accounttype_naked",
					label: "Aktie- & fondkonto",
					value: "yes",
					checked: !onboardingInfo.has_naked_account || customerState.chk_accounttype_naked === "yes",
					onChange: checked => this.setCustomerState({chk_accounttype_naked: !onboardingInfo.has_naked_account || checked ? "yes" : "no"})
				},
				{
					name: "chk_accounttype_isk",
					label: "Investeringssparkonto",
					value: "yes",
					checked: customerState.chk_accounttype_isk === "yes",
					onChange: checked => this.setCustomerState({chk_accounttype_isk: checked ? "yes" : "no"})
				},
				{
					name: "chk_accounttype_kf",
					label: "Depå kapitalförsäkring",
					value: "yes",
					checked: customerState.chk_accounttype_kf === "yes",
					onChange: checked => this.setCustomerState({chk_accounttype_kf: checked ? "yes" : "no"})
				},
				{
					name: "chk_accounttype_tp",
					label: "Depå tjänstepensionsförsäkring",
					value: "yes",
					checked: customerState.chk_accounttype_tp === "yes",
					onChange: checked => this.setCustomerState({chk_accounttype_tp: checked ? "yes" : "no"})
				}
			];
		}

		return (
			<div style={{width: "100%"}}>
				<DefaultFields fields={this.fields}/>

				<div className="Cob-view2-fields">
					<h3>Kontoval</h3>

					<p>
						Följande konton kommer att öppnas.

						{state.workflow !== "futur" && (
							<span> Aktie- & fondkontot är vårt grundkonto och öppnas automatiskt när man blir kund hos oss.</span>
						)}

						{state.workflow !== "futur" && !customer.isCompany && (
							<span> Investeringssparkontot (ISK) är det konto som är mest populärt bland våra kunder.</span>
						)}
					</p>

					<OptionsList
						type="checkbox"
            value={
              customerState.chk_accounttype_naked === "yes"||
              customerState.chk_accounttype_isk === "yes" ||
              customerState.chk_accounttype_kf === "yes" ||
              customerState.chk_accounttype_tp === "yes" ?
               "filled" :
               ""
            }
						orientation="horizontal"
						options={accountTypeOptions}
						style={{marginTop: "5px", maxWidth: "none"}}
            validation={value => (value && value === "filled") || false}
            highlightErrors={highlightErrors}
            readOnly={readOnly}
					/>

					<h4>Rekommendation*</h4>

					<TextView
						name="account_selection_recommendation"
						label={`Fritext (${2000 - customerState.account_selection_recommendation.length} tecken kvar)`}
						value={customerState.account_selection_recommendation}
						maxLength={2000}
						validation={value => value.length > 0}
						resize="vertical"
						onChange={({target}) => this.setCustomerState({account_selection_recommendation: target.value})}
						fullWidth
						minHeight={160}
            highlightErrors={highlightErrors}
            readOnly={readOnly}
					/>

				</div>
			</div>
		);
	}

	static getViewInitialStateForCustomer(customer, workflow)
	{
		workflow = workflow == null ? "default" : workflow;

		let initialState = {
			workflow: workflow,
			isFulfilled: false,
			customerState: {
				account_selection_recommendation: customer.getData("account_selection_recommendation") || "",
				chk_accounttype_naked: customer.getData("chk_accounttype_naked"),
				chk_accounttype_isk: customer.getData("chk_accounttype_isk"),
				chk_accounttype_kf: customer.getData("chk_accounttype_kf"),
				chk_accounttype_tp: customer.getData("chk_accounttype_tp")
			}
		};

		if (workflow === "futur")
		{
			initialState.customerState.chk_accounttype_kf = "yes";
		}
		return initialState;
	}

	static getFields()
	{
		return [
			"account_selection_recommendation",

			"chk_accounttype_naked",
			"chk_accounttype_isk",
			"chk_accounttype_kf",
			"chk_accounttype_tp",

			"account_no_depa",
			"account_no_isk",
			"account_no_kf",
			"account_no_tp"
		];
	}
}

// PRIVATE FUNCTIONS
function _getInitialState()
{
	const {customer, currentWorkflow, onboardingInfo} = this.props;

	let newState = AccountSelection.getViewInitialStateForCustomer(customer, currentWorkflow);

	if (!onboardingInfo.has_naked_account)
	{
		customer._formData['chk_accounttype_naked'] = "yes";
		newState.customerState.chk_accounttype_naked = "yes";
	}

	newState.isFulfilled = this.isFulfilled(newState);
	return newState;
}